import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { ExcessRefundFetchRequest, ExcessRefundTypes } from "./types";
import { fetchExcessRefundByExternalIdApi, fetchExcessRefundApi } from "./api";
import { SagaIterator } from "@redux-saga/core";


function* fetchExcessRefundByExternalId({ payload, type }: ExcessRefundFetchRequest): SagaIterator {
  try {
    const response = yield call(fetchExcessRefundByExternalIdApi, payload);
    yield put({
      type: ExcessRefundTypes.FETCH_EXCESS_REFUND_BY_EXTERNAL_ID_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: ExcessRefundTypes.FETCH_EXCESS_REFUND_BY_EXTERNAL_ID_FAIL,
      payload: { error: error }
    });
  }
}

function* fetchExcessRefund({ payload, type }: ExcessRefundFetchRequest): SagaIterator {
  try {
    const response = yield call(fetchExcessRefundApi, payload);
    yield put({
      type: ExcessRefundTypes.FETCH_EXCESS_REFUND_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: ExcessRefundTypes.FETCH_EXCESS_REFUND_ERROR,
      payload: { error: error }
    });
  }
}

export function* watchFetchExcessRefund() {
  yield takeEvery(ExcessRefundTypes.FETCH_EXCESS_REFUND_REQUEST, fetchExcessRefund);
}

export function* watchFetchExcessRefundByExternalId() {
  yield takeEvery(ExcessRefundTypes.FETCH_EXCESS_REFUND_BY_EXTERNAL_ID_REQUEST, fetchExcessRefundByExternalId);
}

function* ExcessRefundSaga() {
  yield all([fork(watchFetchExcessRefund), fork(watchFetchExcessRefundByExternalId)]);
}

export default ExcessRefundSaga;
